import React, { Component } from 'react'
import { connect } from 'react-redux'
import ProductEditForm from './ProductEditForm'
import { updateProduct, saveOldProduct, clearSuccessMessage, resetInMemoryProduct } from './products-reducer'

class ProductEditFormContainer extends Component {
  componentWillMount () {
    const {product, updateProduct, clearSuccessMessage, resetInMemoryProduct} = this.props
    resetInMemoryProduct()
    updateProduct(product)
    clearSuccessMessage()
  }

  render () {
    const {
      inMemoryProduct,
      updateProduct,
      saveOldProduct,
      requestOngoing,
      successMsg,
      productId,
      product
    } = this.props

    if (!product) {
      return <h4>Product not found</h4>
    }

    return (
      <div>
        <h4>Products Edit Form {productId}</h4>
        <ProductEditForm
          productName={inMemoryProduct.name}
          productId={productId}
          productManufacturer={inMemoryProduct.manufacturer}
          onProductChange={updateProduct}
          onProductSave={() => saveOldProduct(inMemoryProduct)}
          requestOngoing={requestOngoing}
          successMsg={successMsg}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ products }, {match: {params: {productId}}}) => ({
  productId: decodeURIComponent(productId),
  product: products.products.find(({_id}) => _id === decodeURIComponent(productId)),
  inMemoryProduct: products.inMemoryProduct,
  error: products.error,
  requestOngoing: products.requestOngoing,
  successMsg: products.successMsg
})

const mapDispatchToProps = {
  updateProduct,
  saveOldProduct,
  clearSuccessMessage,
  resetInMemoryProduct
}

export default connect(mapStateToProps, mapDispatchToProps)(
  ProductEditFormContainer
)



// WEBPACK FOOTER //
// ./src/products/ProductEditFormContainer.js